import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import { getPostLoginRoute, persistJwtSession } from "../../services/auth";
import CenterLoader from "../../components/loader";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { evaluateAndReturn } from "../../Utils/common";
import { Box, Typography, Button, Paper } from "@mui/material";

const RedirectURLValidUser = () => {
    const navigate = useNavigate();
    const [userMessage, setUserMessage] = useState("");
    const [loading, setLoading] = useState(true);

useEffect(() => {
    const fetchRedirectData = async () => {
        try {
            setLoading(true);
            const response = await api.get("Account/validuser", {
                withCredentials: true,
                skipAuthHeader: true,
            });
            const jwt = response.data;

            if (jwt) {
                const userData = await persistJwtSession(jwt);
                const activeAccountId = sessionStorage.getItem("activeAccountId");
                
                const userId = userData?.userid || sessionStorage.getItem('userid'); 

                if (!activeAccountId || activeAccountId === "null") {
                    navigate("/dashboard"); 
                    return;
                }

                try {
                    const permResponse = await api.get(`Account/permissions/${userId}/${activeAccountId}`);
                    if (permResponse.data?.success) {
                        const permissions = permResponse.data.data.permissions || [];
                        sessionStorage.setItem('userPermissions', JSON.stringify(permissions));
                    }
                } catch (permErr) {
                    console.error("Failed to fetch user permissions", permErr);
                }

                const roleForRoute = userData?.rolename || userData?.role_name || sessionStorage.getItem('rolename');
                navigate(getPostLoginRoute(roleForRoute));
                return;
            }

            setLoading(false);
            navigate("/dashboard");
        } catch (err) {
            setLoading(false);
            setUserMessage(err.response?.data?.errorMessages?.[0]?.message || "Unable to validate user.");
        }
    };

        fetchRedirectData();
    }, [navigate]);
  const goBack = () => {
        localStorage.removeItem('userDtls');
        localStorage.removeItem('accessToken');
        navigate('/');
    };

    if (loading) {
        return <CenterLoader text="Fetching user..." />;
    }

    return (
        <>
            {evaluateAndReturn(
                userMessage,
                <Box
                    sx={{
                        height: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "background.default",
                        px: 2,
                    }}
                >
                    <Paper
                        elevation={3}
                        sx={{
                            p: 4,
                            maxWidth: 400,
                            textAlign: "center",
                            borderRadius: 3,
                        }}
                    >
                        <ErrorOutlineIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
                        <Typography variant="h5" gutterBottom>
                            User Not Found
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            {userMessage || "The user you are looking for does not exist or may have been removed."}
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={goBack}
                            sx={{ borderRadius: 2, px: 4 }}
                        >
                            Go Home
                        </Button>
                    </Paper>
                </Box>,
                <CenterLoader text="Fetching user..." />
            )}
        </>
    );
};

export default RedirectURLValidUser;


 